import { render, staticRenderFns } from "./delaccount.vue?vue&type=template&id=474f30d2&scoped=true"
import script from "./delaccount.vue?vue&type=script&lang=js"
export * from "./delaccount.vue?vue&type=script&lang=js"
import style0 from "./delaccount.vue?vue&type=style&index=0&id=474f30d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474f30d2",
  null
  
)

export default component.exports